import { render } from "./BallotCardList.vue?vue&type=template&id=20195406"
import script from "./BallotCardList.vue?vue&type=script&lang=js"
export * from "./BallotCardList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__